import { EMPTY_STRING, SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType } from '@src/core/enums';
import { arcToFixed } from "./arc-to-fixed";

export const arcVelocitasUnit = () => {
  const type = localStorage.getItem(SETTING_UNITS_KEY);
  if (type === UnitType.SI) return 'm/s';
  if (type === UnitType.IMPERIAL) return 'mph';
  return '';
};

export const arcVelocitas = (value?: number | null) => {

  const payload = Number(value);

  const type = localStorage.getItem(SETTING_UNITS_KEY);

  const request = isNaN(payload) ? EMPTY_STRING : arcToFixed(payload);

  if (type === UnitType.SI) return request + ' m/s';

  if (type === UnitType.IMPERIAL) return request + ' mph';
  
  return EMPTY_STRING;
};